import React, { useEffect } from 'react'
import {
  CCol,
  CForm,
  CFormSwitch,
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CFormCheck,
  CFormInput,
  CLoadingButton,
} from '@coreui/react-pro'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'

const GameMenuTheme = (props) => {
  const formik = useFormik({
    initialValues: {
      image_url: props.data?.image_url || '../images/bannerbg1.jpg',
      sidebar_bg_color: props.data?.sidebar_bg_color || '#CA1744',
    },
    enableReinitialize: true,
    onSubmit: (data) => {
      var adminDetails = JSON.parse(localStorage.getItem('admin'))
      data.is_default_sidebar = props.showGameMenuValue
      data.clubId = adminDetails?.id
      CommonService.updateSideBarThemeSetting(data).then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
        }
      })
    },
  })

  return (
    <>
      <CRow>
        <CCol md={12}>
          <CForm className="row g-3" onSubmit={formik.handleSubmit}>
            <div>
              <CFormCheck
                button={{ color: 'success', variant: 'outline' }}
                type="radio"
                name="success-outlined"
                id="default-sidebar-color"
                autoComplete="off"
                value={0}
                label="Default Background"
                checked={props.showGameMenuValue == 0}
                onChange={props.handleSideBarMenuColorChangeStatus}
              />
              &nbsp;
              <CFormCheck
                button={{ color: 'danger', variant: 'outline' }}
                type="radio"
                name="options-outlined"
                value={1}
                id="sidebar-custom-outlined"
                autoComplete="off"
                label="Custom Color"
                checked={props.showGameMenuValue == 1}
                onChange={props.handleSideBarMenuColorChangeStatus}
              />
              {props.showGameMenuValue === 1 && (
                <>
                  <CRow>
                    <CCol md={6} xs={6} className="pt-3">
                      <label htmlFor="sidebar_bg_color" className="fw-bold">
                        Pick Color
                      </label>
                      <CFormInput
                        type="color"
                        id="sidebar_bg_color"
                        name="sidebar_bg_color"
                        value={formik.values.sidebar_bg_color}
                        onChange={formik.handleChange}
                        title="Choose your color"
                      />
                    </CCol>
                    <CCol md={6} xs={6} className="pt-3">
                      <label htmlFor="leftColorInput" className="fw-bold">
                        Hex Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="sidebar_bg_color"
                        value={formik.values.sidebar_bg_color}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </CCol>
                  </CRow>
                </>
              )}
            </div>
            <CCol md={6}>
              <CLoadingButton type="submit" color="success" variant="outline" id="submit">
                Submit
              </CLoadingButton>
            </CCol>
          </CForm>
        </CCol>
      </CRow>
    </>
  )
}

export default GameMenuTheme
